/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Released_ToastInputs */



/**
* | output |
* | --- |
* | "This computer was released" |
*
* @param {License_Released_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_released_toast = /** @type {((inputs?: License_Released_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Released_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cet ordinateur a été libéré")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Computer wurde freigegeben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo computer è stato liberato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Компьютер освобождён")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se liberó este equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已释放此电脑")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このコンピューターを解除しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह कंप्यूटर हटा दिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Este computador foi libertado")
	return /** @type {LocalizedString} */ ("This computer was released")
});